export const approvalRatePerIndustryCode = {
    "101190": 18,
    "103200": 22,
    "103900": 29,
    "105200": 67,
    "108200": 45,
    "108300": 37,
    "108500": 27,
    "108900": 26,
    "109200": 30,
    "110500": 25,
    "133000": 46,
    "141000": 56,
    "142100": 47,
    "142200": 47,
    "142900": 47,
    "151200": 70,
    "152000": 59,
    "162300": 30,
    "162500": 30,
    "162600": 64,
    "162700": 64,
    "162800": 64,
    "181200": 29,
    "181300": 64,
    "201600": 0,
    "204200": 43,
    "212000": 18,
    "222100": 59,
    "222300": 27,
    "222400": 27,
    "222500": 59,
    "222600": 59,
    "234100": 85,
    "236100": 23,
    "251100": 24,
    "254000": 50,
    "255100": 43,
    "255200": 43,
    "255300": 35,
    "259900": 27,
    "263000": 18,
    "264000": 53,
    "266090": 14,
    "271100": 25,
    "274000": 45,
    "282500": 26,
    "289700": 29,
    "289900": 29,
    "310000": 70,
    "321200": 58,
    "321300": 66,
    "323000": 55,
    "324000": 64,
    "325000": 52,
    "329900": 52,
    "331100": 33,
    "331200": 42,
    "331400": 20,
    "331500": 73,
    "331900": 35,
    "332000": 56,
    "352400": 5,
    "370000": 52,
    "381100": 0,
    "382100": 0,
    "410000": 19,
    "421100": 33,
    "422100": 37,
    "422200": 37,
    "429900": 38,
    "431100": 26,
    "431200": 34,
    "432100": 52,
    "432200": 45,
    "432300": 33,
    "432400": 40,
    "433100": 33,
    "433200": 33,
    "433300": 33,
    "433410": 33,
    "433420": 33,
    "433500": 33,
    "434100": 33,
    "434200": 33,
    "435000": 33,
    "436000": 40,
    "439100": 33,
    "439900": 33,
    "461100": 40,
    "461200": 40,
    "461300": 40,
    "461400": 40,
    "461500": 40,
    "461600": 40,
    "461710": 40,
    "461790": 40,
    "461810": 40,
    "461890": 40,
    "461900": 40,
    "462200": 21,
    "463100": 16,
    "463210": 25,
    "463220": 25,
    "463410": 28,
    "463420": 36,
    "463600": 14,
    "463700": 49,
    "463800": 25,
    "463900": 24,
    "464100": 20,
    "464210": 33,
    "464310": 25,
    "464420": 30,
    "464500": 31,
    "464610": 21,
    "464620": 44,
    "464800": 44,
    "464910": 67,
    "464990": 38,
    "465000": 24,
    "466100": 8,
    "466400": 27,
    "467200": 14,
    "467300": 37,
    "468600": 10,
    "468700": 17,
    "468900": 15,
    "469000": 15,
    "471110": 29,
    "471120": 29,
    "471130": 29,
    "471200": 29,
    "472100": 29,
    "472200": 29,
    "472300": 29,
    "472400": 29,
    "472500": 29,
    "472600": 29,
    "472700": 29,
    "474000": 29,
    "475100": 29,
    "475210": 29,
    "475220": 29,
    "475300": 29,
    "475400": 29,
    "475510": 29,
    "475520": 29,
    "475530": 29,
    "475590": 29,
    "476100": 29,
    "476200": 29,
    "476310": 29,
    "476320": 29,
    "476330": 29,
    "476400": 29,
    "476910": 29,
    "476920": 29,
    "476990": 29,
    "477110": 29,
    "477120": 29,
    "477210": 29,
    "477220": 29,
    "477300": 38,
    "477410": 29,
    "477420": 29,
    "477500": 29,
    "477610": 29,
    "477620": 29,
    "477700": 29,
    "477800": 29,
    "477900": 29,
    "478200": 43,
    "478300": 37,
    "479100": 40,
    "479200": 40,
    "493100": 17,
    "493200": 16,
    "493300": 24,
    "493400": 30,
    "493900": 16,
    "494100": 16,
    "494200": 23,
    "521000": 5,
    "522120": 24,
    "522220": 29,
    "522300": 50,
    "522400": 28,
    "522500": 11,
    "522600": 22,
    "523100": 11,
    "523200": 29,
    "532000": 19,
    "533000": 40,
    "552000": 56,
    "553000": 22,
    "554000": 29,
    "559000": 22,
    "561110": 24,
    "561190": 22,
    "561200": 22,
    "562100": 31,
    "562200": 31,
    "563010": 25,
    "563020": 25,
    "564000": 29,
    "581100": 67,
    "581900": 66,
    "582100": 62,
    "582900": 41,
    "591100": 66,
    "591200": 74,
    "592000": 67,
    "602000": 48,
    "603100": 65,
    "603900": 39,
    "612000": 40,
    "619000": 10,
    "621000": 60,
    "622000": 46,
    "629000": 36,
    "631000": 48,
    "639100": 39,
    "639200": 37,
    "642110": 14,
    "642120": 39,
    "642200": 44,
    "643200": 44,
    "649220": 44,
    "649230": 44,
    "649910": 44,
    "649990": 44,
    "661200": 0,
    "661900": 29,
    "662200": 57,
    "663000": 0,
    "681100": 9,
    "681200": 38,
    "682030": 22,
    "682040": 19,
    "683110": 33,
    "683120": 16,
    "683210": 7,
    "691000": 41,
    "692000": 49,
    "702000": 56,
    "711100": 69,
    "711210": 54,
    "711220": 62,
    "711290": 49,
    "712020": 43,
    "712090": 33,
    "721000": 48,
    "722000": 60,
    "731110": 69,
    "731190": 47,
    "731200": 38,
    "732000": 100,
    "733000": 70,
    "741100": 56,
    "741200": 76,
    "741300": 65,
    "741400": 65,
    "742000": 74,
    "743000": 59,
    "749100": 72,
    "749910": 21,
    "749990": 45,
    "750000": 56,
    "771100": 38,
    "771200": 38,
    "772100": 41,
    "772200": 45,
    "773200": 22,
    "773910": 38,
    "773990": 38,
    "774000": 13,
    "775100": 40,
    "775200": 40,
    "781000": 48,
    "782000": 22,
    "791100": 42,
    "791200": 30,
    "799000": 29,
    "800100": 29,
    "800900": 39,
    "811000": 45,
    "812100": 30,
    "812210": 58,
    "812290": 27,
    "812300": 30,
    "813000": 55,
    "821000": 29,
    "822000": 34,
    "823000": 39,
    "824000": 40,
    "829100": 40,
    "829900": 40,
    "841200": 62,
    "842500": 30,
    "855100": 77,
    "855200": 68,
    "855300": 37,
    "855900": 71,
    "856100": 40,
    "856900": 60,
    "862100": 27,
    "862200": 56,
    "862300": 42,
    "869100": 67,
    "869200": 67,
    "869300": 77,
    "869400": 64,
    "869500": 76,
    "869600": 54,
    "869700": 40,
    "869900": 67,
    "879100": 40,
    "879910": 6,
    "881010": 35,
    "889990": 54,
    "901100": 68,
    "901200": 68,
    "901300": 68,
    "902010": 54,
    "902020": 61,
    "903910": 72,
    "903920": 72,
    "913000": 68,
    "931100": 30,
    "931200": 30,
    "931300": 36,
    "931900": 30,
    "932990": 30,
    "951000": 22,
    "952100": 29,
    "952200": 40,
    "952300": 50,
    "952400": 71,
    "952900": 39,
    "953110": 47,
    "953120": 27,
    "953190": 30,
    "953200": 37,
    "954000": 40,
    "961010": 7,
    "961020": 19,
    "962100": 36,
    "962200": 54,
    "962300": 42,
    "963000": 58,
    "964000": 54,
    "969100": 54,
    "969900": 54,
    "033000": 33,
}
